import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter, infoFormatter, infoFormatterIntl, userFIOFormatter,
} from '../../../../utils/formatters';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function RepresentativeView({
  representative = {}, fieldsValidation, prefix = 'representative.', isPreview, currentApplication,
}) {
  const {
    document_of_authority_number,
    document_of_authority_issue_date,
    document_of_authority_expiration_date,
    inn,
    email,
    representative_name,
    phone,
    address,
    organization_name,
  } = representative;

  const files = currentApplication?.files || [];
  const representative_identity_files = files && files.length ? files.find(item => item.collection_name === 'representative_identity_files') : undefined;
  const representative_document_scan = files && files.length ? files.find(item => item.collection_name === 'representative_document_scan') : undefined;

  function FullRepresentativeView() {
    return (
      <>
        <Row className="row-cols-3">
          {infoFormatterIntl('last_name', representative?.last_name, fieldsValidation, `${prefix}last_name`)}
          {infoFormatterIntl('first_name', representative?.first_name, fieldsValidation, `${prefix}first_name`)}
          {infoFormatterIntl('middle_name', representative?.middle_name, fieldsValidation, `${prefix}middle_name`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl(`${prefix}organization_name`, organization_name, {}, `${prefix}organization_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.inn', inn, fieldsValidation, `${prefix}inn`)}
          {infoFormatterIntl('location_address', address, fieldsValidation, `${prefix}address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative_identity_files', representative_identity_files ? <FileView readOnly withoutMime withoutHr files={[representative_identity_files]} /> : null, fieldsValidation, 'media.representative_identity_files', 6)}
          {infoFormatterIntl('representative.document_of_authority_number', document_of_authority_number, fieldsValidation, `${prefix}document_of_authority_number`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.document_of_authority_issue_date', dateFormatter(document_of_authority_issue_date), fieldsValidation, `${prefix}document_of_authority_issue_date`)}
          {infoFormatterIntl('representative.document_of_authority_expiration_date', dateFormatter(document_of_authority_expiration_date), fieldsValidation, `${prefix}document_of_authority_expiration_date`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('representative_document_scan', representative_document_scan ? <FileView readOnly withoutMime withoutHr files={[representative_document_scan]} /> : null, fieldsValidation, 'media.representative_document_scan', 6)}
        </Row>
      </>
    );
  }

  function PreviewRepresentativeView() {
    return (
      <>
        <Row className="row-cols-3">
          {infoFormatterIntl('last_name', representative?.last_name, fieldsValidation, `${prefix}last_name`)}
          {infoFormatterIntl('first_name', representative?.first_name, fieldsValidation, `${prefix}first_name`)}
          {infoFormatterIntl('middle_name', representative?.middle_name, fieldsValidation, `${prefix}middle_name`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl(`${prefix}organization_name`, organization_name, {}, `${prefix}organization_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.inn', inn, fieldsValidation, `${prefix}inn`)}
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
          {infoFormatterIntl('representative_identity_files', representative_identity_files ? <FileView readOnly withoutMime withoutHr files={[representative_identity_files]} /> : null, fieldsValidation, 'media.representative_identity_files', 6)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.document_of_authority_number', document_of_authority_number, fieldsValidation, `${prefix}document_of_authority_number`)}
          {infoFormatterIntl('representative.document_of_authority_issue_date', dateFormatter(document_of_authority_issue_date), fieldsValidation, `${prefix}document_of_authority_issue_date`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.document_of_authority_expiration_date', dateFormatter(document_of_authority_expiration_date), fieldsValidation, `${prefix}document_of_authority_expiration_date`)}
          {infoFormatterIntl('representative_document_scan', representative_document_scan ? <FileView readOnly withoutMime withoutHr files={[representative_document_scan]} /> : null, fieldsValidation, 'media.representative_document_scan', 6)}
        </Row>
      </>
    );
  }

  return isPreview ? <PreviewRepresentativeView /> : <FullRepresentativeView />;
}
